export const BRAND = {
  name: "넥서스솔루션",
  nameEn: "NEXUS SOLUTION",
  slogan: "기술과 전략이 만나 비즈니스의 다음 단계를 엽니다",
  intro:
    "넥서스솔루션은 디지털 전환, 클라우드, 데이터 분석 분야에서 기업의 성장을 돕는 B2B 컨설팅·SI 기업입니다. 12년간 200여 고객사와 함께하며 검증된 실행력을 제공합니다.",
  address: "서울특별시 영등포구 여의대로 108, 파크원타워 32F",
  phone: "02-777-4500",
  email: "contact@nexus-solution.co.kr",
};

export const NAV = [
  { id: "services", label: "서비스" },
  { id: "about", label: "회사소개" },
  { id: "cases", label: "고객사례" },
  { id: "team", label: "팀" },
  { id: "contact", label: "문의" },
];

export const STATS = [
  { value: "12", unit: "년", label: "업력" },
  { value: "200", unit: "+", label: "고객사" },
  { value: "48", unit: "명", label: "전문 인력" },
  { value: "96", unit: "%", label: "재계약률" },
];

export const SERVICES = [
  {
    title: "디지털 전환 컨설팅",
    desc: "업무 프로세스 진단부터 시스템 로드맵, 실행까지 원스톱 지원",
    items: ["현황 진단", "DX 로드맵", "PoC 설계", "조직 변화 관리"],
  },
  {
    title: "클라우드·인프라",
    desc: "AWS·Azure 기반 아키텍처 설계와 마이그레이션",
    items: ["클라우드 전환", "DevOps 구축", "보안·모니터링", "비용 최적화"],
  },
  {
    title: "데이터·AI 플랫폼",
    desc: "데이터 파이프라인과 분석·AI 서비스 구축",
    items: ["데이터 웨어하우스", "BI 대시보드", "AI PoC", "거버넌스"],
  },
  {
    title: "웹·앱 개발",
    desc: "브랜드 사이트부터 사내 시스템까지 맞춤 개발",
    items: ["기업 홈페이지", "고객 포털", "관리자 시스템", "API 연동"],
  },
];

export const PROCESS = [
  { step: "01", title: "요구 분석", desc: "비즈니스 목표와 현황 파악" },
  { step: "02", title: "전략 수립", desc: "범위·일정·ROI 제안" },
  { step: "03", title: "설계·개발", desc: "애자일 기반 단계별 실행" },
  { step: "04", title: "운영·고도화", desc: "모니터링과 지속 개선" },
];

export const CASES = [
  { client: "A 제조 그룹", industry: "제조", result: "생산 데이터 실시간 대시보드 구축 · 보고 시간 70% 단축" },
  { client: "B 금융사", industry: "금융", result: "레거시 마이그레이션 · 연간 운영비 32% 절감" },
  { client: "C 유통 기업", industry: "유통", result: "옴니채널 회원 포털 · 전환율 18% 개선" },
];

export const TEAM = [
  { name: "정우진 대표", role: "CEO · DX Strategy", focus: "전략 컨설팅 15년" },
  { name: "한서연 이사", role: "Cloud Architect", focus: "AWS/Azure 인증 보유" },
  { name: "오민수 팀장", role: "Data Lead", focus: "데이터 플랫폼·AI" },
  { name: "윤지아 팀장", role: "Dev Lead", focus: "풀스택·SI 프로젝트" },
];

export const CLIENTS = ["삼성 계열", "현대 계열", "KB 금융", "CJ 그룹", "네이버", "카카오"];
